import React from 'react'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'
import IntervenersList from './IntervenersList'
import IntervenerCards from './IntervenerCards'

export default function DeletedIntervenersTab ({ interveners }) {
  const screens = useBreakpoint()

  return (
    <>
      { !screens.xs && <IntervenersList interveners={interveners} /> }
      { screens.xs && <IntervenerCards interveners={interveners} /> }
    </>
  )
}
